import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { CreateCurriculumSection } from '../create-curriculum-section';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useFormContext } from 'react-hook-form';
import { JobportalAddEducationButton } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-add-education/jobportal-add-education-button';
import type { AddEducationSchemaType } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-add-education/jobportal-add-education-dialog';
import { JobportalAddEducationDialog } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-add-education/jobportal-add-education-dialog';
import { JobportalEducationCard } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-add-education/jobportal-education-card';
import { useResponsiveDialogStore } from '@eliadmin/core/src/components/ui/responsive-dialog';
import type { CreateCurriculumSchema } from '@eliadmin/core/src/pages/(jobportal)/create-curriculum/page';

export const CreateCurriculumStep4 = () => {
  const { t } = useTranslations();

  const form = useFormContext<CreateCurriculumSchema>();

  const openDialog = useResponsiveDialogStore(s => s.open);

  const educations = form.watch('educations');

  const handleEducationEdit = (education: AddEducationSchemaType) => {
    if (education.id === undefined) return;

    const newEducations = educations?.map((e: AddEducationSchemaType) => {
      if (e.id === education.id) {
        return education;
      }
      return e;
    });
    form.setValue('educations', newEducations as any);
  };

  const handleEducationEditClick = (education: AddEducationSchemaType) => {
    openDialog({
      id: JobportalAddEducationDialog.id,
      content: <JobportalAddEducationDialog onEdit={handleEducationEdit} dataToEdit={education} />,
    });
  };

  const handleEducationDelete = (education: AddEducationSchemaType) => {
    const newEducations = educations?.filter((e: AddEducationSchemaType) => e.id !== education.id);
    form.setValue('educations', newEducations || []);
  };

  const handleEducationDeleteClick = (education: AddEducationSchemaType) => {
    handleEducationDelete(education);
  };
  return (
    <div className={cn('create-curriculum-step-wrapper flex w-full flex-col gap-4')}>
      <CreateCurriculumSection title={t('text864')}>
        <p className="text-[#63626F]">{t('text1752')}</p>
        <div className={cn('flex flex-col gap-2', 'ea-jobportal-add-education__cards-wrapper')}>
          {educations?.length === 0 && (
            <p className={cn('p-6 text-muted-foreground', 'text-sm')}>{t('text991')}</p>
          )}
          {educations?.map((education, index) => (
            <JobportalEducationCard
              key={index}
              education={education}
              onEducationEditClick={() => handleEducationEditClick(education)}
              onEducationDeleteClick={handleEducationDeleteClick}
            />
          ))}
        </div>
        <JobportalAddEducationButton />
      </CreateCurriculumSection>
    </div>
  );
};
